// @flow
import * as React from 'react';
import type { Match, RouterHistory } from 'react-router-dom';
import { Box } from 'grommet';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import UpperContainer from 'esm-web-pro/components/layout/sidePanel/UpperContainer';
import FiberActions from 'esm-web-pro/containers/pages/network/objects/fiber/FiberActions';
import FiberAttributes from 'esm-web-pro/containers/pages/network/objects/fiber/FiberAttributes';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import type { FiberDetailedRepresentation } from 'esm-web-pro/types/networks';
import type { Map } from 'esm-web-pro/containers/map/types';
import FiberIcon from 'esm-web-pro/components/layout/sidePanel/icons/FiberIcon';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import ModelAttributes from 'esm-web-pro/containers/pages/network/ModelAttributes';
import MapPoint from 'esm-web-pro/containers/pages/network/objects/MapPoint';
import BottomContainer from 'esm-web-pro/components/layout/sidePanel/BottomContainer';
import NavigateBackButton from 'esm-web-pro/components/maps/NavigateBackButton';
import MapFiber from './MapFiber';

type Props = {
    panelId: String,
    object: FiberDetailedRepresentation,
    map: Map,
    history: RouterHistory,
    match: Match,
    updateObject: (data: FiberDetailedRepresentation) => void,
    editor: BaseEditor,
}

const Fiber = (props: Props) => {
    const {
        object: fiber, map: networkMap, match, updateObject, editor, panelId,
    } = props;


    let MapFiberComponent = MapFiber;
    let restProps = { fiber };

    if (fiber.container.start_container_point.id === fiber.container.end_container_point.id) {
        MapFiberComponent = MapPoint;
        restProps = { point: fiber.container.start_container_point };
    }

    return (
        <MapFiberComponent editor={editor} {...restProps}>
            {(handleView) => (
                <SidePane
                    id={panelId}
                    openInitially
                    closeAllOpened
                    title={fiber.sequence_number}
                    titleLabel={<FormattedMessage id="fiber-sidepanel-title" defaultMessage="Fiber" />}
                    titleIcon={<FiberIcon />}
                    titleOnView={handleView}
                    actions={<NavigateBackButton panelId={panelId} />}
                >
                    <Box height="100%" justify="between">
                        <Box flex>
                            <UpperContainer>
                                <HorizontalLine color="grey" />
                                <FiberAttributes fiber={fiber} url={match.url} onView={handleView} />
                                <HorizontalLine color="grey" />
                                <Box direction="row">
                                    <FiberActions
                                        fiber={fiber}
                                        map={networkMap}
                                        updateObject={updateObject}
                                        editor={editor}
                                    />
                                </Box>
                                <HorizontalLine color="grey" />
                            </UpperContainer>
                            <BottomContainer background="white" />
                        </Box>

                        <Route
                            path={`${match.path}/model/:modelCode`.replace('//', '/')}
                            render={({ match: _match }) => (
                                <ModelAttributes url={_match.url} />
                            )}
                        />
                    </Box>
                </SidePane>
            )}
        </MapFiberComponent>
    );
};

export default withRouter(Fiber);
